var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 10.625L9 2.375L0.999999 10.625","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowTop.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
